var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { makeStyles, Popper } from "@material-ui/core";
import classNames from "classnames";
export const FTLDropdownMenu = React.forwardRef((_a, ref) => {
    var _b, _c;
    var { children, containerRef, className, menuWidth, menuHeight = "auto", open = true } = _a, otherProps = __rest(_a, ["children", "containerRef", "className", "menuWidth", "menuHeight", "open"]);
    const classes = useStyles({
        menuWidth: menuWidth
            ? menuWidth
            : (_c = (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) !== null && _c !== void 0 ? _c : "auto",
        menuHeight,
    });
    return (React.createElement(Popper, Object.assign({ ref: ref, open: open, className: classNames(className, classes.menu), anchorEl: containerRef.current }, otherProps), children));
});
const useStyles = makeStyles((theme) => ({
    menu: ({ menuWidth, menuHeight, }) => ({
        zIndex: 1310,
        overflow: "hidden",
        border: "0.5px solid #EBEDF0",
        backgroundColor: theme.palette.text.onColor,
        boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.04), 0px 4px 4px rgba(0, 0, 0, 0.08)",
        borderRadius: 4,
        width: menuWidth,
        height: menuHeight,
        margin: "8px 0",
        padding: "8px 0",
    }),
}));
//# sourceMappingURL=FTLDropdownMenu.js.map